import GroupItem from "./GroupItem"

import classes from './Group.module.css'
import NoDataInput from "./NoDataInput"

const GroupContainer = ({data, dataId, label, folder, fieldsData, apiCase, smsMail}) => {
    // when adding to a different folder, need to check GroupItemSearch.js to change the api call accordingly

    return <>
        {data[label] && <GroupItem data={data[label]} dataId={dataId} groupData={data} label={label} folder={folder} fieldsData={fieldsData} apiCase={apiCase} smsMail={smsMail}/>} 
        {!data[label]  && <div className={classes.row}>
            {/* {label == 'case_manager' && <NoDataInput data={data[label]} dataId={dataId} groupData={data} label={'Legacy Case Manager'} folder={folder} fieldsData={fieldsData} apiCase={apiCase}/>} */}
            <NoDataInput data={data[label]} dataId={dataId} groupData={data} label={label} folder={folder} fieldsData={fieldsData} apiCase={apiCase}/>
        </div>}
    </>
}

export default GroupContainer